import React, { useEffect, useState, useRef } from 'react';
import {
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    TextField,
    Typography,
    Select,
    MenuItem,
    Grid,
    Button,
    Switch,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import {
    updateAuthProviderByCustomerId, disableSSOProviderByCustomerId,
    getAuthProviderByCustomerId, getSSOProviderHistory
} from "apis/CustomersApis";

const { primary, secondary, text, tableRow, transparent } = colors;
const { size } = typography;
import Box from '@mui/material/Box';


const SsoMobile = ({ selectedCustomer, authProviderList, tabValue, isCustomerDataEmpty }) => {
    const APP_TYPE = "mobile";
    const OKTA_AUTH_PROVIDER = "Okta";
    const AZURE_AUTH_PROVIDER = "AzureAD";
    const MAVRIC_AUTH_PROVIDER = "Mavric";
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [isValid, setIsValid] = useState(false);
    // const [selectedCustomer, setSelectedCustomer] = useState({ customer_id: 0, org_name: "" });

    const [mobileSsoAuthProvider, setMobileSsoAuthProvider] = useState("");
    const [authProviderData, setAuthProviderData] = useState({});
    const [mobileClientId, setMobileClientId] = useState("");
    const [mobileTenantId, setMobileTenantId] = useState("");
    const [mobileClientSecret, setMobileClientSecret] = useState("");
    // const [mobileOktaClientSecret, setMobileOktaClientSecret] = useState("");
    const [mobileIssuer, setMobileIssuer] = useState("");
    const [mobileIsAzureAdProvider, setMobileIsAzureAdProvider] = useState(false);
    const [mobileIsOktaProvider, setMobileIsOktaProvider] = useState(false);
    const [mobileDisableSso, setMobileDisableSso] = useState(false);
    // const [isCustomerDataEmpty, setIsCustomerDataEmpty] = useState(false);
    const [mobileIsDisabledInput, setMobileIsDisabledInput] = useState(
        ((selectedCustomer.sso_auth_provider_mobile === MAVRIC_AUTH_PROVIDER &&
            selectedCustomer.sso_enabled_mobile === false) ? true : false)
    );
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const prevCustomerId = useRef(null);
    const prevTabValue = useRef(null);
    const [previousSettings, setPreviousSettings] = useState(null);
    const prevSsoAuthProviderRef = useRef(mobileSsoAuthProvider);

    const checkValidity = () => {
        let isValidInput = true;
        switch (mobileSsoAuthProvider) {
            case OKTA_AUTH_PROVIDER:
                if (mobileClientId.trim() !== '' && mobileIssuer !== '') {
                    isValidInput = true;
                    setIsValid(true);
                } else {
                    isValidInput = false;
                    setIsValid(false);
                }
                break;
            case AZURE_AUTH_PROVIDER:
                if (mobileClientId.trim() !== '' && mobileTenantId !== '' && mobileClientSecret !== '') {
                    isValidInput = true;
                    setIsValid(true);
                } else {
                    isValidInput = false;
                    setIsValid(false);
                }
                break;
            default:
                isValidInput = true;
                setIsValid(true);

        }
        return isValidInput
    };

    const getAuthProviderDataByCustomerId = (customerId, app) => {
        // console.log("Fetching SSO AuthProvider for Customer ID:", customerId);
        return new Promise(function (resolve, reject) {
            getAuthProviderByCustomerId(customerId, app)  // API call to get SSO AuthProvider details
                .then((response) => {
                    setAuthProviderData(response);
                    // console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    setAuthProviderData([]);
                    let errMessage = '';
                    if (error.response) {
                        errMessage = error.response.data.message;
                        if (error.response.status === 401 || error.response.status === 403) {
                            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                            dispatch(logout(jsonPostMsg));
                            history.push('/login');
                        }
                    } else if (error.request) {
                        errMessage = `${error}`;
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                        errMessage = error.message;
                    }
                    reject(errMessage);
                });
        });
    };

    const fetchPreviousSettings = async (provider) => {
        try {
            const response = await getSSOProviderHistory(selectedCustomer.customer_id, APP_TYPE, provider);
            setPreviousSettings(response);
            // console.log("History data:", response);
            // console.log("Current data:", authProviderData);
            // console.log("isHistoryValid:", isHistoryValid(authProviderData, previousSettings));
            // Check if current data is valid 
            const hasCurrentValidData = authProviderData &&
                authProviderData.auth_provider !== MAVRIC_AUTH_PROVIDER &&
                ((provider === AZURE_AUTH_PROVIDER && authProviderData.client_id && authProviderData.tenant_id && authProviderData.client_secret) ||
                    (provider === OKTA_AUTH_PROVIDER && authProviderData.client_id && authProviderData.issuer));

            if (hasCurrentValidData) {
                // console.log("Showing current settings (existing user)");
                if (provider === AZURE_AUTH_PROVIDER) {
                    setMobileClientId(authProviderData.client_id || "");
                    setMobileTenantId(authProviderData.tenant_id || "");
                    setMobileClientSecret(authProviderData.client_secret || "");
                } else if (provider === OKTA_AUTH_PROVIDER) {
                    setMobileClientId(authProviderData.client_id || "");
                    setMobileIssuer(authProviderData.issuer || "");
                }
            } else if (response) {
                // console.log("Showing history settings (new user with history)");
                if (provider === AZURE_AUTH_PROVIDER) {
                    setMobileClientId(response.client_id || '');
                    setMobileTenantId(response.tenant_id || '');
                    setMobileClientSecret(response.client_secret || '');
                } else if (provider === OKTA_AUTH_PROVIDER) {
                    setMobileClientId(response.client_id || '');
                    setMobileIssuer(response.issuer || '');
                }
            } else {
                // console.log("No settings available - clearing fields");
                setMobileClientId('');
                setMobileTenantId('');
                setMobileClientSecret('');
                setMobileIssuer('');
            }

        } catch (error) {
            console.error('Error fetching SSO history:', error);
            setPreviousSettings(null);
        }
    };

    useEffect(() => {
        if (prevSsoAuthProviderRef.current !== mobileSsoAuthProvider) {
            setMobileClientId("");
            setMobileClientSecret("");
        }
        if (mobileSsoAuthProvider === AZURE_AUTH_PROVIDER || mobileSsoAuthProvider === OKTA_AUTH_PROVIDER) {
            fetchPreviousSettings(mobileSsoAuthProvider);
        }
        prevSsoAuthProviderRef.current = mobileSsoAuthProvider;
    }, [mobileSsoAuthProvider]);


    useEffect(() => {
        if (authProviderData) {
            const provider = authProviderData.sso_enabled ? authProviderData.auth_provider : MAVRIC_AUTH_PROVIDER;

            setMobileSsoAuthProvider(provider);

            // Update form fields 
            setMobileClientId(authProviderData.client_id || "");
            setMobileIssuer(authProviderData.issuer || "");
            setMobileTenantId(authProviderData.tenant_id || "");
            setMobileClientSecret(authProviderData.client_secret || "");
            // setMobileOktaClientSecret(authProviderData.client_secret || "");

            // setSelectedCustomer(prev => ({
            //     ...prev,
            //     sso_auth_provider: provider,
            //     sso_enabled: authProviderData.sso_enabled,
            //     client_id: authProviderData.client_id,
            //     issuer: authProviderData.issuer,
            //     tenant_id: authProviderData.tenant_id,
            //     client_secret: authProviderData.client_secret
            // }));

            // setMobileDisableSso(authProviderData.sso_enabled_mobile || false);
            setMobileDisableSso(!authProviderData.sso_enabled);
            setMobileIsDisabledInput(provider === MAVRIC_AUTH_PROVIDER);
        }
    }, [authProviderData]);

    useEffect(() => {
        checkValidity();
    }, [mobileClientId, mobileTenantId, mobileClientSecret, mobileIssuer, mobileSsoAuthProvider, mobileIsAzureAdProvider, mobileIsOktaProvider]);

    useEffect(() => {
        switch (mobileSsoAuthProvider) {
            case OKTA_AUTH_PROVIDER:
                setMobileIsAzureAdProvider(false);
                setMobileIsOktaProvider(true);
                if (authProviderData && authProviderData.auth_provider == MAVRIC_AUTH_PROVIDER && (!checkValidity())) {
                    setIsValid(false);
                } else (checkValidity());
                break;
            case AZURE_AUTH_PROVIDER:
                setMobileIsAzureAdProvider(true);
                setMobileIsOktaProvider(false);
                if (authProviderData && authProviderData.auth_provider == MAVRIC_AUTH_PROVIDER && (!checkValidity())) {
                    setIsValid(false);
                } else (checkValidity());
                break;
            default:
                setMobileIsAzureAdProvider(false);
                setMobileIsOktaProvider(false);
                setIsValid(true);
        }
    }, [mobileSsoAuthProvider]);

    const handleCloseConfirmation = () => {
        setOpenConfirmationDialog(false);
    };

    const handleOpenConfirmation = () => {
        setOpenConfirmationDialog(true);
    };

    useEffect(() => {
        // console.log("selectedCustomer:", selectedCustomer);

        if (tabValue !== 1 || !selectedCustomer || !selectedCustomer.customer_id) return;
        // if ( tabValue === prevTabValue.current && selectedCustomer.customer_id === prevCustomerId.current ) return;

        if (tabValue === prevTabValue.current && selectedCustomer.customer_id === prevCustomerId.current) {
            return;
        }

        getAuthProviderDataByCustomerId(selectedCustomer.customer_id, APP_TYPE).finally(
            () => {
                prevTabValue.current = tabValue;
                prevCustomerId.current = selectedCustomer.customer_id;
                // setIsInitialLoad(false);
            }
        )


    }, [tabValue, selectedCustomer]);

    const onChangeDisabledSso = (e) => {
        let isChecked = e.target.checked;
        // console.log("Disable SSO:", isChecked);
        setMobileDisableSso(!isChecked);
        const isMavricMobileAuth = selectedCustomer.sso_auth_provider_mobile === MAVRIC_AUTH_PROVIDER;
        setMobileIsDisabledInput(!isChecked);
        if (!isChecked) {
            setIsValid(checkValidity());
        } else {
            setIsValid(isChecked);
        }
    }

    // useEffect(() => {
    //     getAuthProviderData();
    // }, []);

    const shouldUpdateProvider = () => {

        if (mobileSsoAuthProvider === OKTA_AUTH_PROVIDER) {
            return (
                selectedCustomer.sso_auth_provider_mobile !== mobileSsoAuthProvider ||
                selectedCustomer.client_id !== mobileClientId ||
                selectedCustomer.issuer !== mobileIssuer
            );
        }

        if (mobileSsoAuthProvider === AZURE_AUTH_PROVIDER) {
            return (
                selectedCustomer.sso_auth_provider_mobile !== mobileSsoAuthProvider ||
                selectedCustomer.client_id !== mobileClientId ||
                selectedCustomer.tenant_id !== mobileTenantId ||
                selectedCustomer.client_secret !== mobileClientSecret
            );
        }
        return false;
    };



    const handleSaveClick = async (event) => {
        event.preventDefault();

        try {

            if (selectedCustomer.customer_id === null) return;

            if (selectedCustomer.sso_auth_provider_mobile !== MAVRIC_AUTH_PROVIDER && mobileDisableSso) {
                await disableSSOProviderByCustomerId(selectedCustomer.customer_id, APP_TYPE);

                setMobileSsoAuthProvider(MAVRIC_AUTH_PROVIDER);
                setMobileClientId("");
                setMobileTenantId("");
                setMobileClientSecret("");
                // setMobileOktaClientSecret("");
                setMobileIssuer("");
                setMobileDisableSso(false);
                setMobileIsDisabledInput(true);

                // await getAuthProviderDataByCustomerId(selectedCustomer.customer_id, 'mobile');

            } else if (shouldUpdateProvider()) {
                let identityProvider = null;
                if (mobileSsoAuthProvider === OKTA_AUTH_PROVIDER) {
                    identityProvider = {
                        "auth_provider": OKTA_AUTH_PROVIDER,
                        "client_id": mobileClientId,
                        "issuer": mobileIssuer,
                        // "client_secret": mobileOktaClientSecret
                    };
                } else if (mobileSsoAuthProvider === AZURE_AUTH_PROVIDER) {
                    identityProvider = {
                        "auth_provider": AZURE_AUTH_PROVIDER,
                        "client_id": mobileClientId,
                        "tenant_id": mobileTenantId,
                        "client_secret": mobileClientSecret
                    };
                }
                console.log("[SAVE from mobile] Okta payload = ", identityProvider);
                if (identityProvider) {
                    await updateAuthProviderByCustomerId(
                        selectedCustomer.customer_id,
                        mobileSsoAuthProvider,
                        identityProvider,
                        APP_TYPE
                    );
                    // await getAuthProviderDataByCustomerId(selectedCustomer.customer_id, 'mobile');
                }
            }
            // await getAuthProviderData();
            await getAuthProviderDataByCustomerId(selectedCustomer.customer_id, APP_TYPE);

            handleCloseConfirmation();
        } catch (error) {
            console.error("Error while updating auth provider:", error);
            alert("An error occurred. Please try again.");
        }
    };


    return (
        <div>
            <Box
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    padding: 2,
                    // borderRadius: 2,
                    // maxWidth: "600px",
                    width: "100%",
                    // boxShadow: 3,
                    // border: `1px solid red`
                }}
            >
                <Typography
                    variant="body2"
                    color={theme.palette.secondary.main}
                    sx={{ fontWeight: 600, mb: 2 }}
                    gutterBottom
                >
                    SSO Settings
                </Typography>


                <Grid container>
                    <Typography
                        variant="body2"
                        fontSize={size.sm}
                        justifyContent="center"
                        color={text.main}
                        sx={{ fontWeight: 400, mb: 1 }}>
                        Customer Name:&nbsp;{selectedCustomer ? (selectedCustomer.org_name !== null ? selectedCustomer.org_name : '') : ''}
                    </Typography>
                </Grid>


                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <Switch
                            checked={!mobileDisableSso}
                            onChange={onChangeDisabledSso}
                            sx={{ mb: 1 }}
                            disabled={isCustomerDataEmpty}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </Grid>
                    <Grid item>
                        <Typography
                            variant="body2"
                            fontSize={size.sm}
                            justifyContent="center"
                            color={text.main}
                            sx={{ fontWeight: 400, mb: 1 }}>
                            {mobileDisableSso ? 'Enable the SSO?' : 'Disable the SSO?'}
                        </Typography>
                    </Grid>
                </Grid>


                <Grid container direction="column" spacing={2}>
                    {/* {disableSso && ( */}
                    <Grid item sx={{ marginBottom: 2 }}>
                        <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400, }}>
                            Single-Sign-On (SSO) Provider
                        </Typography>
                        <Select
                            sx={{
                                width: 300,
                                ".MuiSelect-select": {
                                    paddingTop: "8px !important",
                                    paddingBottom: "8px !important",
                                    minHeight: "35px !important",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "1em !important",
                                },
                            }}
                            id="authProvider"
                            name="authProvider"
                            // value={ssoAuthProvider}
                            value={mobileDisableSso ? MAVRIC_AUTH_PROVIDER : mobileSsoAuthProvider || MAVRIC_AUTH_PROVIDER}
                            onChange={(e) => setMobileSsoAuthProvider(e.target.value)}
                            displayEmpty
                            disabled={mobileIsDisabledInput}
                        >
                            {authProviderList.map((item, idx) => (
                                <MenuItem key={`authProviderItem${idx}`} value={item.auth_provider}>
                                    {item.auth_provider}
                                </MenuItem>
                            ))}

                            {!authProviderList.some(p => p.auth_provider === MAVRIC_AUTH_PROVIDER) && (
                                <MenuItem value={MAVRIC_AUTH_PROVIDER} style={{ display: "none" }}>
                                    {MAVRIC_AUTH_PROVIDER}
                                </MenuItem>
                            )}
                        </Select>
                    </Grid>
                    {/* )} */}

                    {mobileDisableSso ? (
                        <></>
                    ) : (
                        // Show SSO fields when switch is ON and provider is selected
                        (mobileIsAzureAdProvider || mobileIsOktaProvider) && (
                            <Grid container spacing={2} sx={{ paddingLeft: "18px" }}>
                                <Grid item xs={4} sx={{ paddingLeft: "18px" }}>
                                    <Typography
                                        variant="body2"
                                        fontSize={size.sm}
                                        color={text.main}
                                        sx={{ fontWeight: 400 }}
                                    >
                                        Single-Sign-On (SSO) Client Id*
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        id="ssoCustomerId"
                                        name="ssoCustomerId"
                                        placeholder="Enter SSO Application/Client Id"
                                        autoComplete="off"
                                        value={mobileClientId}
                                        onChange={(e) => setMobileClientId(e.target.value)}
                                        variant="outlined"
                                        InputProps={{ sx: { paddingLeft: 0.5 } }}
                                        disabled={mobileIsDisabledInput}
                                    />
                                </Grid>

                                {mobileIsOktaProvider ? (
                                    <>
                                        <Grid item xs={4}>
                                            <Typography
                                                variant="body2"
                                                fontSize={size.sm}
                                                color={text.main}
                                                sx={{ fontWeight: 400 }}
                                            >
                                                Single-Sign-On (SSO) Issuer*
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                id="ssoIssuer"
                                                name="ssoIssuer"
                                                placeholder="Enter SSO Issuer"
                                                autoComplete="off"
                                                value={mobileIssuer}
                                                onChange={(e) => setMobileIssuer(e.target.value)}
                                                variant="outlined"
                                                InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                disabled={mobileIsDisabledInput}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={4}>
                                            <Typography
                                                variant="body2"
                                                fontSize={size.sm}
                                                color={text.main}
                                                sx={{ fontWeight: 400 }}
                                            >
                                                Single-Sign-On (SSO) Client Secret*
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                id="ssoOktaClientSecret"
                                                placeholder="Enter SSO Password/Client Secret"
                                                autoComplete="off"
                                                value={mobileOktaClientSecret}
                                                onChange={(e) => setMobileOktaClientSecret(e.target.value)}
                                                variant="outlined"
                                                InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                disabled={mobileIsDisabledInput}
                                            />
                                        </Grid> */}
                                    </>
                                ) : (
                                    <>
                                        <Grid item xs={4}>
                                            <Typography
                                                variant="body2"
                                                fontSize={size.sm}
                                                color={text.main}
                                                sx={{ fontWeight: 400 }}
                                            >
                                                Single-Sign-On (SSO) Tenant Id*
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                id="ssoTenantId"
                                                placeholder="Enter SSO Tenant Id"
                                                autoComplete="off"
                                                value={mobileTenantId}
                                                onChange={(e) => setMobileTenantId(e.target.value)}
                                                variant="outlined"
                                                InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                disabled={mobileIsDisabledInput}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography
                                                variant="body2"
                                                fontSize={size.sm}
                                                color={text.main}
                                                sx={{ fontWeight: 400 }}
                                            >
                                                Single-Sign-On (SSO) Client Secret*
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                id="ssoClientSecret"
                                                placeholder="Enter SSO Password/Client Secret"
                                                autoComplete="off"
                                                value={mobileClientSecret}
                                                onChange={(e) => setMobileClientSecret(e.target.value)}
                                                variant="outlined"
                                                InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                disabled={mobileIsDisabledInput}
                                            />
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        )
                    )}

                </Grid>
                <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                    <Button variant="contained" color="secondary" onClick={handleOpenConfirmation} disabled={!isValid || isCustomerDataEmpty} sx={{ borderRadius: "4px", padding: "10px 20px" }}>
                        Save
                    </Button>
                </Box>
            </Box>

            <Dialog
                open={openConfirmationDialog}
                onClose={handleCloseConfirmation}
                fullScreen={fullScreen}
                // maxWidth={maxWidth}
                // scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'Confirmation'}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    Are you sure you want to save the changes?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmation} color="secondary" variant="contained">
                        No
                    </Button>
                    <Button onClick={handleSaveClick} color="secondary" variant="contained" >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default SsoMobile
